import moment from 'moment-timezone';
import { ReactElement } from 'react';
import { ScheduleBadgeContainer } from '../styles';
import { CalendarSimpleIcon, WatchIcon } from 'icons';
import { colors } from 'styles/remoteControlColors';
import { t } from 'i18next';

interface ScheduleBadgeProps {
  readonly beginTime?: string;
  readonly endTime?: string;
}

export function ScheduleBadge({
  beginTime,
  endTime,
}: ScheduleBadgeProps): ReactElement {
  function formatTime(time: string): string {
    const splitTime = time.split(':');

    return `${parseInt(splitTime[0], 10)}h${splitTime[1]}`;
  }

  function renderFormattedDate(): string {
    const momentDate = moment(new Date());
    return `${momentDate.format('ddd')}, ${momentDate.format('DD/MM/YYYY')}`;
  }

  return (
    <ScheduleBadgeContainer isEmpty={!beginTime && !endTime}>
      <div>
        <CalendarSimpleIcon color={colors.Grey500} />
        <p style={{ textTransform: 'capitalize' }}>
          {renderFormattedDate()}
        </p>
      </div>
      <div style={{ display: 'flex', flexShrink: 0 }}>
        <WatchIcon color={colors.Grey500} size={16} />
        {beginTime && endTime ? (
          <p>
            {formatTime(beginTime)}
            {' '}
            -
            {' '}
            {formatTime(endTime)}
          </p>
        ) : (
          <p style={{ maxWidth: '140px', textAlign: 'center' }}>
            {t('semProgramacaoFuncionamentoEstaData')}
          </p>
        )}
      </div>
    </ScheduleBadgeContainer>
  );
}
